import "./index.scss";

import { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Confetti from "react-confetti";
import { SwitchTransition, CSSTransition } from "react-transition-group";
import { getClosingContest } from "../../redux/contests/selectors";
import { formatNumber } from "../../services/utility/utils";
// import { getRound } from "../../utils/utils";
// import { ReactComponent as UpDownIcon } from "../../assets/images/up-down-icon.svg";
// import { ReactComponent as UpDownIcon2 } from "../../assets/images/up-down-icon_v1.svg";

// import { ReactComponent as Sunburst } from "../../assets/images/sunburst.svg";
import { useTheme } from "../../hook/useThemes";
import useScreen, { SCREEN_LIST } from "../../hook/useScreen";
// import ResultOld from "./component/ResultOld";
import ResultNew from "./component/ResultNew/ResultNew";
import Wining from "./component/Wining";
import { getRound } from "../../utils/utils";
import { setSimulatingCount } from "../../redux/auth/actions";
import Cancelled from "./component/Cancelled";

type ClosingContestProps = {
  children: any;
};

const ClosingContest = ({ children }: ClosingContestProps) => {
  const auth = useSelector((state: any) => state?.auth);
  const simulatingCount = auth?.simulatingCount || 0;

  const dispatch = useDispatch();

  const contest = useSelector(getClosingContest);
  const [isClosing, setIsClosing] = useState(false);
  const [isWinning, setIsWinning] = useState(false);
  const [showTada, setShowTada] = useState(false);
  const [isWinningEnd, setIsWinningEnd] = useState(false);
  const [isShowLose, setIsShowLose] = useState(false);
  const [newContest, setNewContest] = useState<any>({});
  const [isShowCancelled, setIsShowCancelled] = useState<boolean>(false);

  const refTimeOutSimulating = useRef<any>();

  const { lang, operatorId, callProfile } = useTheme();
  const { settingColorWin } = useTheme();

  const heightScreen = useScreen();
  const isMinHeight = heightScreen < SCREEN_LIST.screenHeight3;

  const refId = useRef<any>("");
  const refInterval = useRef<any>();
  const refTimeout = useRef<any>();
  const refTimeoutEnd = useRef<any>();
  const refTimeoutEndWin = useRef<any>();
  const refClosePrice = useRef<any>(0);

  const refOdds = useRef<any>(0);

  useEffect(() => {
    const limitClosingTime = () => {
      const closeDiff =
        Date.now() - new Date(contest?.contestCloseTime).getTime();
      if (closeDiff < 20000 && !contest?.closePrice) {
        setIsClosing(true);
        refId.current = contest?.id;
        setIsWinning(false);
        setNewContest(contest);
      }
    };

    limitClosingTime();
    refInterval.current = setInterval(limitClosingTime, 500);

    return () => {
      window.clearInterval(refInterval.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contest?.closePrice]);

  // set simulatingCount
  useEffect(() => {
    if (
      contest &&
      (contest?.status?.toLowerCase() === "voided" ||
        !!contest?.isSimulating) &&
      isClosing &&
      !isShowCancelled
    ) {
      if (refTimeOutSimulating.current) {
        window.clearTimeout(refTimeOutSimulating.current);
      }
      refTimeOutSimulating.current = setTimeout(() => {
        refTimeOutSimulating.current = undefined;

        console.log(
          "close",
          contest?.status?.toLowerCase() === "voided",
          "=",
          !!contest?.isSimulating
        );

        dispatch(setSimulatingCount(simulatingCount + 1));
        setIsShowCancelled(true);

        window.clearInterval(refInterval.current);
        window.clearTimeout(refTimeout.current);
      }, 1000);
      return;
    }
    if (
      contest &&
      !contest?.isSimulating &&
      isClosing &&
      !isShowCancelled &&
      contest?.status?.toLowerCase() !== "voided"
    ) {
      if (refTimeOutSimulating.current) {
        window.clearTimeout(refTimeOutSimulating.current);
      }
      refTimeOutSimulating.current = setTimeout(() => {
        refTimeOutSimulating.current = undefined;
        dispatch(setSimulatingCount(0));
      }, 1000);
      return;
    }

    return () => {
      window.clearTimeout(refTimeOutSimulating.current);
    };
  }, [contest, isClosing]);

  useEffect(() => {
    let t = null;
    if (isShowCancelled && isClosing) {
      t = setTimeout(() => {
        setIsClosing(false);
        setIsShowCancelled(false);
      }, 3000);
    }

    return () => {
      window.clearInterval(t);
    };
  }, [isShowCancelled, isClosing]);

  useEffect(() => {
    console.log(
      "contest?.closePrice",
      contest?.closePrice,
      contest?.id,
      refId.current,
      !refClosePrice.current
    );
    if (
      !!contest?.closePrice &&
      refId.current === contest?.id &&
      !refClosePrice.current &&
      contest?.status?.toLowerCase() !== "voided" &&
      !contest?.isSimulating
    ) {
      refClosePrice.current = contest?.closePrice;
      const isWinningResult = !contest?.position
        ? false
        : (contest?.position === "rekt" &&
            contest?.closePrice !== 0 &&
            contest?.closePrice < contest?.livePrice) ||
          (contest?.position === "moon" &&
            contest?.closePrice !== 0 &&
            contest?.closePrice > contest?.livePrice);

      setShowTada(isWinningResult);

      if (!isWinningResult) {
        if (contest?.position) {
          setIsShowLose(true);
        }
        refTimeout.current = setTimeout(() => {
          console.log("0");
          setIsClosing(false);
          setIsWinningEnd(false);
          setIsWinning(false);
          setShowTada(false);
          refClosePrice.current = "";
          refId.current = "";
          setNewContest({});
          setIsShowLose(false);
        }, 3000);
        return;
      }

      refTimeout.current = setTimeout(() => {
        console.log("1");
        setIsWinning(isWinningResult);
      }, 1000);

      refTimeoutEndWin.current = setTimeout(() => {
        console.log("2");
        setIsWinningEnd(true);
      }, 3700);

      refTimeoutEnd.current = setTimeout(() => {
        console.log("3");
        setIsClosing(false);
        setIsWinningEnd(false);
        setIsWinning(false);
        setShowTada(false);
        refClosePrice.current = "";
        refId.current = "";
        setNewContest({});
        setIsShowLose(false);
      }, 4000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contest?.closePrice]);

  useEffect(() => {
    return () => {
      window.clearTimeout(refTimeoutEnd.current);
      window.clearTimeout(refTimeout.current);
      window.clearTimeout(refTimeoutEndWin.current);
    };
  }, []);

  useMemo(() => {
    if (isWinning) {
      callProfile();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isWinning]);

  const betAbove = newContest?.position === "moon";
  const isAbove = refClosePrice.current > newContest?.livePrice;

  if (!isWinning) {
    refOdds.current = betAbove
      ? newContest?.whitelabelMoonOdds
      : newContest?.whitelabelRektOdds;
  }

  const infoRef = useRef(null);
  const contestRef = useRef(null);
  const nodeRef = isClosing ? contestRef : infoRef;

  return (
    <div className="closing-contest-wrapper">
      {isWinning && isClosing && (
        <div className="confetti-wrapper">
          <Confetti
            gravity={0.1}
            numberOfPieces={500}
            colors={settingColorWin || ["#4FFA3B", "#C38147", "#F94A4D"]}
          />
        </div>
      )}
      <SwitchTransition>
        <CSSTransition
          key={`${isClosing}`}
          nodeRef={nodeRef}
          addEndListener={(done) => {
            nodeRef.current.addEventListener("transitionend", done, {
              once: true,
              capture: false,
            });
          }}
          className="switch-zoom"
        >
          {isWinning && isClosing && contest?.wager ? (
            <Wining
              isWinning={true}
              value={contest?.wager * refOdds.current}
              endWin={isWinningEnd}
              lang={lang}
            />
          ) : (
            <div ref={nodeRef}>
              {isClosing ? (
                <div className="wrap-result">
                  <div
                    className={`animate__animated ${
                      isShowCancelled && "animate__fadeOut"
                    }`}
                  >
                    <ResultNew
                      contest={{
                        ...newContest,
                        closePrice: refClosePrice.current || 0,
                      }}
                      betAbove={betAbove}
                      lang={lang}
                      isWinning={isWinning}
                      odds={refOdds.current}
                      isMinHeight={isMinHeight}
                      operatorId={operatorId}
                      isAbove={isAbove}
                      showTada={showTada}
                      isShowLose={isShowLose}
                    />
                  </div>
                  {isShowCancelled && (
                    <Cancelled round={getRound(contest?.contestLiveTime)} />
                  )}
                </div>
              ) : (
                // <ResultOld
                //   contest={contest}
                //   betAbove={betAbove}
                //   lang={lang}
                //   isWinning={isWinning}
                //   odds={odds}
                //   isMinHeight={isMinHeight}
                //   operatorId={operatorId}
                //   isAbove={isAbove}
                // />
                children
              )}
            </div>
          )}
        </CSSTransition>
      </SwitchTransition>
    </div>
  );
};

export default ClosingContest;
